import { render } from "./TabPermission.vue?vue&type=template&id=1ae6c16f"
import script from "./TabPermission.vue?vue&type=script&lang=js"
export * from "./TabPermission.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__